"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Ads API
 * The Spotify Ads API.
 *
 * The version of the OpenAPI document: 3.0.0
 * Contact: selfserve-infra-api@spotify.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.AdSetResponseToJSON = exports.AdSetResponseFromJSONTyped = exports.AdSetResponseFromJSON = exports.instanceOfAdSetResponse = void 0;
var runtime_1 = require("../runtime");
var AdSetStatus_1 = require("./AdSetStatus");
var AssetFormat_1 = require("./AssetFormat");
var BidStrategyResponse_1 = require("./BidStrategyResponse");
var BudgetResponse_1 = require("./BudgetResponse");
var CostModel_1 = require("./CostModel");
var Delivery_1 = require("./Delivery");
var DeliveryGoal_1 = require("./DeliveryGoal");
var FrequencyCap_1 = require("./FrequencyCap");
var Pacing_1 = require("./Pacing");
var Promotion_1 = require("./Promotion");
var Targets_1 = require("./Targets");
var VideoDeliveryFormat_1 = require("./VideoDeliveryFormat");
/**
 * Check if a given object implements the AdSetResponse interface.
 */
function instanceOfAdSetResponse(value) {
    var isInstance = true;
    return isInstance;
}
exports.instanceOfAdSetResponse = instanceOfAdSetResponse;
function AdSetResponseFromJSON(json) {
    return AdSetResponseFromJSONTyped(json, false);
}
exports.AdSetResponseFromJSON = AdSetResponseFromJSON;
function AdSetResponseFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'name': !(0, runtime_1.exists)(json, 'name') ? undefined : json['name'],
        'startTime': !(0, runtime_1.exists)(json, 'start_time') ? undefined : (new Date(json['start_time'])),
        'endTime': !(0, runtime_1.exists)(json, 'end_time') ? undefined : (new Date(json['end_time'])),
        'frequencyCaps': !(0, runtime_1.exists)(json, 'frequency_caps') ? undefined : (new Set(json['frequency_caps'].map(FrequencyCap_1.FrequencyCapFromJSON))),
        'bidMicroAmount': !(0, runtime_1.exists)(json, 'bid_micro_amount') ? undefined : json['bid_micro_amount'],
        'delivery': !(0, runtime_1.exists)(json, 'delivery') ? undefined : (0, Delivery_1.DeliveryFromJSON)(json['delivery']),
        'datasetId': !(0, runtime_1.exists)(json, 'dataset_id') ? undefined : json['dataset_id'],
        'spanFreezeAt': !(0, runtime_1.exists)(json, 'span_freeze_at') ? undefined : (new Date(json['span_freeze_at'])),
        'iasCampaignId': !(0, runtime_1.exists)(json, 'ias_campaign_id') ? undefined : json['ias_campaign_id'],
        'videoDeliveryFormats': !(0, runtime_1.exists)(json, 'video_delivery_formats') ? undefined : (new Set(json['video_delivery_formats'].map(VideoDeliveryFormat_1.VideoDeliveryFormatFromJSON))),
        'id': !(0, runtime_1.exists)(json, 'id') ? undefined : json['id'],
        'category': !(0, runtime_1.exists)(json, 'category') ? undefined : json['category'],
        'categories': !(0, runtime_1.exists)(json, 'categories') ? undefined : json['categories'],
        'campaignId': !(0, runtime_1.exists)(json, 'campaign_id') ? undefined : json['campaign_id'],
        'costModel': !(0, runtime_1.exists)(json, 'cost_model') ? undefined : (0, CostModel_1.CostModelFromJSON)(json['cost_model']),
        'createdAt': !(0, runtime_1.exists)(json, 'created_at') ? undefined : (new Date(json['created_at'])),
        'updatedAt': !(0, runtime_1.exists)(json, 'updated_at') ? undefined : (new Date(json['updated_at'])),
        'assetFormat': !(0, runtime_1.exists)(json, 'asset_format') ? undefined : (0, AssetFormat_1.AssetFormatFromJSON)(json['asset_format']),
        'budget': !(0, runtime_1.exists)(json, 'budget') ? undefined : (0, BudgetResponse_1.BudgetResponseFromJSON)(json['budget']),
        'promotion': !(0, runtime_1.exists)(json, 'promotion') ? undefined : (0, Promotion_1.PromotionFromJSON)(json['promotion']),
        'bidStrategy': !(0, runtime_1.exists)(json, 'bid_strategy') ? undefined : (0, BidStrategyResponse_1.BidStrategyResponseFromJSON)(json['bid_strategy']),
        'rejectReason': !(0, runtime_1.exists)(json, 'reject_reason') ? undefined : json['reject_reason'],
        'status': !(0, runtime_1.exists)(json, 'status') ? undefined : (0, AdSetStatus_1.AdSetStatusFromJSON)(json['status']),
        'targets': !(0, runtime_1.exists)(json, 'targets') ? undefined : (0, Targets_1.TargetsFromJSON)(json['targets']),
        'pacing': !(0, runtime_1.exists)(json, 'pacing') ? undefined : (0, Pacing_1.PacingFromJSON)(json['pacing']),
        'mobileAppId': !(0, runtime_1.exists)(json, 'mobile_app_id') ? undefined : json['mobile_app_id'],
        'salesforceLineItemId': !(0, runtime_1.exists)(json, 'salesforce_line_item_id') ? undefined : json['salesforce_line_item_id'],
        'rateCardType': !(0, runtime_1.exists)(json, 'rate_card_type') ? undefined : json['rate_card_type'],
        'deliveryGoal': !(0, runtime_1.exists)(json, 'delivery_goal') ? undefined : (0, DeliveryGoal_1.DeliveryGoalFromJSON)(json['delivery_goal']),
    };
}
exports.AdSetResponseFromJSONTyped = AdSetResponseFromJSONTyped;
function AdSetResponseToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'name': value.name,
        'start_time': value.startTime === undefined ? undefined : (value.startTime.toISOString()),
        'end_time': value.endTime === undefined ? undefined : (value.endTime.toISOString()),
        'frequency_caps': value.frequencyCaps === undefined ? undefined : (Array.from(value.frequencyCaps).map(FrequencyCap_1.FrequencyCapToJSON)),
        'bid_micro_amount': value.bidMicroAmount,
        'delivery': (0, Delivery_1.DeliveryToJSON)(value.delivery),
        'dataset_id': value.datasetId,
        'span_freeze_at': value.spanFreezeAt === undefined ? undefined : (value.spanFreezeAt.toISOString()),
        'ias_campaign_id': value.iasCampaignId,
        'video_delivery_formats': value.videoDeliveryFormats === undefined ? undefined : (Array.from(value.videoDeliveryFormats).map(VideoDeliveryFormat_1.VideoDeliveryFormatToJSON)),
        'id': value.id,
        'category': value.category,
        'categories': value.categories,
        'campaign_id': value.campaignId,
        'cost_model': (0, CostModel_1.CostModelToJSON)(value.costModel),
        'created_at': value.createdAt === undefined ? undefined : (value.createdAt.toISOString()),
        'updated_at': value.updatedAt === undefined ? undefined : (value.updatedAt.toISOString()),
        'asset_format': (0, AssetFormat_1.AssetFormatToJSON)(value.assetFormat),
        'budget': (0, BudgetResponse_1.BudgetResponseToJSON)(value.budget),
        'promotion': (0, Promotion_1.PromotionToJSON)(value.promotion),
        'bid_strategy': (0, BidStrategyResponse_1.BidStrategyResponseToJSON)(value.bidStrategy),
        'reject_reason': value.rejectReason,
        'status': (0, AdSetStatus_1.AdSetStatusToJSON)(value.status),
        'targets': (0, Targets_1.TargetsToJSON)(value.targets),
        'pacing': (0, Pacing_1.PacingToJSON)(value.pacing),
        'mobile_app_id': value.mobileAppId,
        'salesforce_line_item_id': value.salesforceLineItemId,
        'rate_card_type': value.rateCardType,
        'delivery_goal': (0, DeliveryGoal_1.DeliveryGoalToJSON)(value.deliveryGoal),
    };
}
exports.AdSetResponseToJSON = AdSetResponseToJSON;
